import { render } from "./Invoices.vue?vue&type=template&id=27d856f8"
const script = {}
script.render = render

export default script